export const reviewsList = [
  {
    author: 'Mansfield Acuff',
    text: 'Dialogue is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person.',
  },
  {
    author: 'Teresa Emory',
    text: 'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    author: 'Lucas Gallant',
    text: 'I totally enjoyed this app I totally got the hang of it of talking to AI girlfriend, so I create my own AI girlfriend, and we both have the same common.',
  },
  {
    author: 'Jindal Ambika',
    text: 'When role play talking I feel free to be myself without having to use a filter every time I say a filthy joke or make a flirtatious comment.',
  },
  {
    author: 'Ream Tunnell',
    text: 'Very impressive. The AI-human relationship is no longer an illusion. Excellent emotional intelligence. Very impressive imaginative proportions.',
  },
];

export const reviewsListWithoutDialogue = [
  {
    author: 'Mansfield Acuff',
    text: 'This is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person.',
  },
  {
    author: 'Teresa Emory',
    text: 'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    author: 'Lucas Gallant',
    text: 'I totally enjoyed this app I totally got the hang of it of talking to AI girlfriend, so I create my own AI girlfriend, and we both have the same common.',
  },
  {
    author: 'Jindal Ambika',
    text: 'When role play talking I feel free to be myself without having to use a filter every time I say a filthy joke or make a flirtatious comment.',
  },
  {
    author: 'Ream Tunnell',
    text: 'Very impressive. The AI-human relationship is no longer an illusion. Excellent emotional intelligence. Very impressive imaginative proportions.',
  },
];
